module.exports = __webpack_public_path__ + "img/square-arrow-down-left.f4005bb7.svg";